import Vue from "vue";
import App from "./App.vue";
import router from "./Routes";
import store from "./store/index";
import vuetify from "./plugins/vuetify";
//import * as VueGoogleMaps from 'vue2-google-maps';
//import Toast from "vue-toastification";
//import "vue-toastification/dist/index.css";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import IdleVue from "idle-vue";
import axios from "axios";
import config from "@/config";
import VueCookies from 'vue-cookies';

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

//Vue.use(Toast);

Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.config.productionTip = false;

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 900000,
});

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  headers: {
    // Authorization: "Bearer " + getLocalAccessToken  ,
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          let objtoken;
          try {
            const rs = await refreshToken();

            objtoken = rs;

          } catch (error) {

            swal.fire({
              icon: 'warning',
              text: "Session Timeout!! Please Login ",
            });

            router.push('/login');
          }

          window.localStorage.setItem('token', objtoken.data.token);
          $cookies.set("refreshToken", objtoken.data.refreshToken, "4h");
          //objtoken.data

          return instance(originalConfig);
        } catch (_error) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);


function refreshToken() {

  return instance.post("/api/Customer/RefreshToken/" + getLocalRefreshToken());
}

function getLocalRefreshToken() {

  const refreshToken = $cookies.get("refreshToken");

  //alert(refreshToken)

  return refreshToken;
}

function getLocalAccessToken() {
  const accessToken = window.localStorage.getItem("token");
  return accessToken;
}

Vue.prototype.$http = instance;

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
  store,


  onIdle() {
    window.localStorage.clear();
    this.$router.push("/login");
  },

  logout() {
    this.$router.push("/login");
    window.localStorage.clear();
  },

}).$mount("#app");
